export const colors = {
  primary: '#2D1F40', // Morado profundo
  secondary: '#6EA8F7', // Azul claro
  accent: '#F39C6B', // Naranja cobre
  background: '#EAF4FB', // Azul grisáceo
  text: '#1F1F1F', // Gris oscuro
  darkBackground: '#241D3A', // Morado oscuro semi opaco
  white: '#FFFFFF', // Blanco puro
}

export const fonts = {
  playfair: "'Playfair Display', serif",
  inter: "'Inter', sans-serif",
}

export const breakpoints = {
  mobile: '320px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1200px',
} 